export class GetEmpAvlLeaves {
    year: string;
    employeeId: number;
    typeOfLeave: number;
    constructor(year: string, employeeId: number, typeOfLeave: number) {
        this.year=year;
        this.employeeId=employeeId;
        this.typeOfLeave=typeOfLeave;
    }
}